import { ApiError, fetchWithAuth, TimeoutError } from "../lib/api";
export type RedditQueueState = "needs_reply" | "replied" | "dismissed" | "all";
export interface RedditLead { id:string; source_url:string; score:number; verdict:string; pipeline_state:string; body_preview:string|null; context_snippet:string|null; matched_signals:string[]|{signals?:unknown}|null; raw_payload:Record<string,unknown>|null; created_at:string; credibility_link_url:string|null; digest_item:{id:string;suggested_reply_snapshot:string;credibility_link_snapshot:string|null}|null; latest_revision:{final_text:string;action:string;dismiss_reason:string|null}|null }
export interface RedditQueue { items:RedditLead[]; counts:Record<RedditQueueState,number>; posting_enabled:false }
/**
 * Is this failure the Workbench still warming up, rather than a real outage?
 *
 * THE BOUNDARY — exactly two things count as "waking", and nothing else:
 *  1. The server answered 503 with detail "Reddit answer desk is waking" — it
 *     hit its own 75s gateway timeout (reddit_answer_gateway.py) and said so.
 *  2. NO response arrived at all before our abort deadline. That deadline
 *     (SLOW_FETCH_TIMEOUT_MS, 90s) already exceeds the server's whole 75s
 *     budget, so silence past it means the request is still in the Workbench's
 *     Render free-plan cold start — the one condition a browser genuinely
 *     cannot tell apart from a slow start.
 *
 * Everything the server ACTUALLY ANSWERED stays "unavailable", whatever the
 * status: 503 "Reddit answer desk unavailable", 500, 502, 400/404/409. So does
 * an unreachable API (a rejected fetch that is not our own abort), because the
 * cold service is the Workbench BEHIND LN Pro, and a cold Workbench still
 * answers through LN Pro rather than killing the socket. Widening this any
 * further would just trade one lie for another: a real outage rendering as
 * "waking up, try again" is no more honest than a cold start rendering as
 * "unavailable".
 */
export function isRedditAnswerWakingError(error: unknown): boolean {
 if (error instanceof TimeoutError) return true;
 const detail = error instanceof ApiError && error.body && typeof error.body === "object"
  ? String((error.body as {detail?:unknown}).detail??"") : "";
 return detail === "Reddit answer desk is waking";
}
export const redditAnswerService={
 list:(state:RedditQueueState)=>fetchWithAuth<RedditQueue>(`/admin/content/reddit/queue?state=${state}`),
 action:(id:string,body:{action:"copied"|"marked_replied"|"dismissed";final_text:string;suggested_text:string;dismiss_reason?:string|null})=>fetchWithAuth<{ok:boolean;pipeline_state:string}>(`/admin/content/reddit/${encodeURIComponent(id)}/action`,{method:"POST",body:JSON.stringify(body)})
};
